import { createApp } from 'vue'

// import store from './store'
// import App from './App';
import App from '@/App.vue';
import components from '@/components/UI';
import router from '@/router/router';

const app = createApp(App)

components.forEach(component => {
    app.component(component.name, component)
})

app.use(router).mount('#app')

